import React from 'react';
import { useTranslation } from 'react-i18next';
import { CAPTION_BORDER_RADIUS_RANGE } from '@vbee-holding/aivoice-shared-lib';
import GroupHeader from './controls/GroupHeader';
import ConfigRow from './controls/ConfigRow';
import SliderField from './controls/SliderField';
import ColorField from './controls/ColorField';

const CONTROL_WIDTH = 200;

const HighlightGroup = ({ highlight, onChange }) => {
  const { t } = useTranslation();
  const { enabled } = highlight;

  return (
    <div className="config-group">
      <GroupHeader
        label={t('captionHighlight')}
        badge={t('captionBadgeBeta')}
        enabled={enabled}
        onToggle={(next) => onChange({ enabled: next })}
      />

      <div className="config-group-rows">
        <ConfigRow label={t('captionColor')} disabled={!enabled}>
          <ColorField
            value={highlight.textColor}
            opacity={highlight.textOpacity}
            disabled={!enabled}
            onChange={(textColor) => onChange({ textColor })}
            onOpacityChange={(textOpacity) => onChange({ textOpacity })}
          />
        </ConfigRow>

        <ConfigRow label={t('captionBackground')} disabled={!enabled}>
          <ColorField
            value={highlight.backgroundColor}
            opacity={highlight.backgroundOpacity}
            disabled={!enabled}
            onChange={(backgroundColor) => onChange({ backgroundColor })}
            onOpacityChange={(backgroundOpacity) =>
              onChange({ backgroundOpacity })
            }
          />
        </ConfigRow>

        <ConfigRow label={t('captionBorderRadius')} disabled={!enabled}>
          <SliderField
            width={CONTROL_WIDTH}
            value={highlight.borderRadius}
            range={CAPTION_BORDER_RADIUS_RANGE}
            onChange={(borderRadius) => onChange({ borderRadius })}
          />
        </ConfigRow>
      </div>
    </div>
  );
};

export default HighlightGroup;
